var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlowChartDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 52,
    viewBox: "0 0 223 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.085 51.533C112.739 52.1557 110.261 52.1557 107.915 51.533L9.91886 25.5253C-5.23809 21.5027 -2.21842 -1.32378e-06 13.5034 0L209.496 1.65025e-05C225.218 1.78263e-05 228.238 21.5028 213.081 25.5253L115.085 51.533Z",
    fill: "url(#paint0_linear_7798_23523)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7798_23523",
    x1: 1.99383,
    y1: 13.9958,
    x2: 222.563,
    y2: 14.5347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79B63B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A1E160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79B63B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowChartDownArrow);
export default __webpack_public_path__ + "static/media/flow_chart_down_arrow.df8741dcfa26eb0c8d4bd9132012fad2.svg";
export { ForwardRef as ReactComponent };